module.exports = __webpack_public_path__ + "img/64.6.CODm.9c57586f.png";